var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C17.3018 21.6 21.5999 17.3019 21.5999 12C21.5999 6.69806 17.3018 2.39999 11.9999 2.39999C6.69797 2.39999 2.3999 6.69806 2.3999 12C2.3999 17.3019 6.69797 21.6 11.9999 21.6ZM12.8484 9.24852C13.3171 8.77989 13.3171 8.02009 12.8484 7.55147C12.3798 7.08284 11.62 7.08284 11.1514 7.55147L7.55137 11.1515C7.08275 11.6201 7.08275 12.3799 7.55137 12.8485L11.1514 16.4485C11.62 16.9172 12.3798 16.9172 12.8484 16.4485C13.3171 15.9799 13.3171 15.2201 12.8484 14.7515L11.297 13.2H15.5999C16.2626 13.2 16.7999 12.6627 16.7999 12C16.7999 11.3373 16.2626 10.8 15.5999 10.8H11.297L12.8484 9.24852Z",
    fill: "#6363FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-left.d9258cca7b84505a680a931dd1f6fdee.svg";
export { ForwardRef as ReactComponent };